import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { StoreProvider } from "@/lib/store";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import CartDrawer from "@/components/site/CartDrawer";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import Product from "@/pages/Product";
import Lookbook from "@/pages/Lookbook";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminLookbook from "@/pages/admin/AdminLookbook";

const TOAST_OPTIONS = {
  style: {
    background: "#0a0805",
    border: "1px solid rgba(212,175,55,0.3)",
    color: "#F4D77A",
  },
};

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

// Hide site header/footer on /admin routes
function SiteLayout({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Header />}
      <main>{children}</main>
      {!isAdmin && <Footer />}
      {!isAdmin && <CartDrawer />}
    </>
  );
}

function App() {
  return (
    <StoreProvider>
      <div
        className="App min-h-screen text-white"
        style={{
          background:
            "radial-gradient(1400px 700px at 30% -10%, #14100a 0%, transparent 55%), radial-gradient(900px 500px at 100% 20%, #0a0a0a 0%, transparent 50%), #050505",
          backgroundAttachment: "fixed",
        }}
      >
        <BrowserRouter>
          <ScrollToTop />
          <SiteLayout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/product/:slug" element={<Product />} />
              <Route path="/lookbook" element={<Lookbook />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminProducts />} />
              <Route path="/admin/orders" element={<AdminOrders />} />
              <Route path="/admin/lookbook" element={<AdminLookbook />} />
            </Routes>
          </SiteLayout>
          <Toaster
            position="top-center"
            richColors
            theme="dark"
            toastOptions={TOAST_OPTIONS}
          />
        </BrowserRouter>

        <style>{`
          @keyframes fadeUp {
            from { opacity: 0; transform: translateY(20px); }
            to   { opacity: 1; transform: translateY(0); }
          }
          ::selection { background: rgba(212,175,55,0.35); color: white; }
          html { scroll-behavior: smooth; }
        `}</style>
      </div>
    </StoreProvider>
  );
}

export default App;
